module.exports = __webpack_public_path__ + "static/media/world.9282a06f.geojson";